import { ExternalLink } from 'lucide-react';
import NextLink from 'next/link';
import { useMemo } from 'react';

import { Badge, KeyValueRow, KeyValueTable, Text } from '@/design-system/components/ui';

import { Trigger } from '../../domain';

interface Props {
  trigger: Trigger;
}

export function XFollowTriggerFullDetails({ trigger }: Props) {
  const account = useMemo(() => {
    // Use context (new approach)
    if (trigger.context?.usernameToFollow) {
      return trigger.context.usernameToFollow;
    }

    // @deprecated - Fallback to signature extraction for legacy triggers
    if (trigger.signature) {
      const parts = trigger.signature.split('x-follow-');
      return parts[1] || '';
    }

    return '';
  }, [trigger.context?.usernameToFollow, trigger.signature]);

  const conditionExpression = useMemo(() => {
    return trigger.context?.condition_expression ?? trigger.conditionExpression ?? '-';
  }, [trigger.context?.condition_expression, trigger.conditionExpression]);

  const executedWhenDisplay = useMemo(() => {
    if (!account) return '-';

    const twitterUrl = `https://x.com/${account}`;

    return (
      <div className="tw:flex tw:flex-row tw:gap-2 tw:items-center">
        <Text as="span" variant="body-sm" color="muted">
          User follows
        </Text>
        <NextLink
          href={twitterUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="tw:flex tw:gap-0.5 tw:no-underline"
        >
          <Badge size="sm">
            <div className="tw:flex tw:flex-row tw:gap-1 tw:items-center">
              <span>@{account}</span>
              <ExternalLink size={12} />
            </div>
          </Badge>
        </NextLink>
        <Text as="span" variant="body-sm" color="muted">
          account
        </Text>
      </div>
    );
  }, [account]);

  return (
    <KeyValueTable>
      <KeyValueRow label="Name" value={trigger.name} />
      <KeyValueRow label="Description" value={trigger.description} />
      <KeyValueRow label="Executed when" value={executedWhenDisplay} />
      <KeyValueRow label="Argument conditions" value={conditionExpression} />
    </KeyValueTable>
  );
}
